import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.tom = new TomSelect(this.selectTarget, {
      plugins: ["checkbox_options", "remove_button"],
      onChange: () => {
        clearTimeout(this._submitTimeout)
        this._submitTimeout = setTimeout(() => {
          this.element.requestSubmit()
        }, 400)
      }
    })
  }

  disconnect() {
    this.tom?.destroy()
  }
}
